import { useEffect, useMemo, useState } from "react"
import { SOCKET_URL } from "../../../core/constants/urls"
import { useProfileQuery } from "../../../core/services/react-query/useInternalTransfer"
import { formatDate, formatNumber } from "../../../core/utils/common"
import { Text } from "../../../modules/staking"
import Loading from "../../../pages/trade/common/Loading"
import NoData from "../../../pages/trade/history/NoData"
import { usePersianNames } from "../../../pages/trade/utils"
import { Column, Row } from "../../../styles/TableStyle"
import FilterLayout from "../../layouts/FilterLayout"
import { useOrdersHistoryQuery } from "../../../pages/trade/utils/useHistory"


const P2PHistoryTable = () => {
    const { data: profile } = useProfileQuery()
    const { findPersianName } = usePersianNames()

    const initialState = {
        page: 1,
        dateFrom: null,
        search: {
            _id: '_id'
        },
        query: {
            _id: ''
        },
    }

    const [filterQueries, setFilterQueries] = useState(initialState)

    const { data: history, isLoading, refetch } = useOrdersHistoryQuery(filterQueries)

    const totalPages = useMemo(() => history?.meta?.total || 0, [history])


    useEffect(() => {
        refetch()
    }, [filterQueries, refetch])

    return (
        <div className="min-w-[1000px] overflow-x-auto">
            <FilterLayout
                data={history}
                totalPages={totalPages}
                headers={headers}
                loading={isLoading}
                state={{
                    filterQueries: filterQueries,
                    setFilterQueries: setFilterQueries,
                    initialState,
                }}
            >
                {history?.data?.map((trade, idx) => {
                    let tradeType = trade.order?.type
                    if (profile?._id !== trade.order?.userId) {
                        tradeType = tradeType === 'buy' ? 'sell' : 'buy'
                    }

                    return (
                        <Row
                            key={trade._id}
                        >
                            {/* تاریخ سفارش */}
                            <Column className="w-[10%]">
                                {formatDate(trade.createdAt, 'date', 'Fa-IR')}
                            </Column>

                            {/* بازار */}
                            <Column className="w-[15%]">
                                <div className="flex items-center gap-2">
                                    <img
                                        width={32}
                                        height={32}
                                        src={SOCKET_URL + `assets/icon/${trade?.coin?.toLowerCase()}.png`}
                                        alt={`${trade.coin?.toLowerCase()}.png`}
                                    />
                                    <div className="flex flex-col">
                                        <span>
                                            {`${trade.coin?.toUpperCase()} / ${trade.pair?.toUpperCase()}`}
                                        </span>
                                        <span className="text-gray-400 text-xs">
                                            {`${findPersianName(trade.coin)} / ${findPersianName(trade.pair)}`}
                                        </span>
                                    </div>
                                </div>
                            </Column>

                            {/* سمت */}
                            <Column className="w-[7%]">
                                <Text tid={tradeType} className={tradeType === 'buy' ? 'text-green-400' : 'text-red-400'} />
                            </Column>

                            {/* نوع */}
                            <Column className="w-[8%]">
                                {trade.order?.submit}
                            </Column>

                            {/* مقدار سفارش */}
                            <Column className="w-[10%]">
                                {formatNumber(trade.order?.amount, { type: trade.coin })}
                            </Column>

                            {/* قیمت واحد */}
                            <Column className="w-[10%]">
                                {formatNumber(trade.order?.priceUnit, { type: trade.pair })}
                            </Column>

                            {/* مبلغ کل */}
                            <Column className="w-[10%]">
                                {formatNumber(trade.order?.price, { type: trade.pair })}
                            </Column>

                            {/* مقدار پر شده */}
                            <Column className="w-[10%]">
                                {formatNumber(trade.order?.tradedAmount, { type: trade.coin })}
                            </Column>

                            {/* کارمزد */}
                            <Column className="w-[8%]">
                                0
                            </Column>

                            {/* وضعیت */}
                            <Column className="w-[12%]">
                                {trade.order?.status}
                            </Column>
                        </Row>
                    )
                })}
            </FilterLayout>
        </div>
    )
}

const headers = [
    { title: 'تاریخ سفارش', width: 'w-[10%]' },
    { title: 'بازار', width: 'w-[15%]' },
    { title: 'سمت', width: 'w-[7%]' },
    { title: 'نوع', width: 'w-[8%]' },
    { title: 'مقدار سفارش', width: 'w-[10%]' },
    { title: 'قیمت واحد', width: 'w-[10%]' },
    { title: 'مبلغ کل', width: 'w-[10%]' },
    { title: 'مقدار پر شده', width: 'w-[10%]' },
    { title: 'کارمزد', width: 'w-[8%]' },
    { title: 'وضعیت', width: 'w-[12%]' },
]

export default P2PHistoryTable
